<template>
    <div class="accounting-detail-data accounting-salary-detail">
        <div class="detail-container">
            <div class="detail-section">
                <div class="accounting-detail-items" style="margin-top: 25px;">
                    <div class="item vertical">
                        <div class="label">摘要</div>
                        <div class="value xl b">{{ summaryText }}</div>
                    </div>
                </div>
            </div>
            <div class="detail-section">
                <div class="section-title">固定薪資</div>
                <table cellspacing="0" cellpadding="0" class="accounting-detail-table" style="margin-top: 15px">
                    <thead>
                        <tr>
                            <th>項目</th>
                            <th>付款日期</th>
                            <th>付款帳戶</th>
                            <th class="right">付款金額</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(s, index) in fixedSalaryTableData" :key="index">
                            <td>{{ s.name }}</td>
                            <td>{{ s.dat | dateFormater("YYYY-MM-dd") }}</td>
                            <td>
                                <div v-if="s.bnK_TPC">{{ s.bnK_TPC }}</div>
                                <div v-else-if="s.amt !== 0">零用現金</div>
                            </td>
                            <td class="right"><Money :v="s.amt" /></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="detail-section">
                <div class="section-title">非固定薪資</div>
                <table cellspacing="0" cellpadding="0" class="accounting-detail-table" style="margin-top: 15px">
                    <thead>
                        <tr>
                            <th>項目</th>
                            <th>付款日期</th>
                            <th>付款帳戶</th>
                            <th class="right">付款金額</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(s, index) in nonFixedSalaryTableData" :key="index">
                            <td>{{ s.name }}</td>
                            <td>
                                <span v-if="s.amt">{{ s.dat | dateFormater("YYYY-MM-dd") }}</span>
                            </td>
                            <td>
                                <div v-if="s.bnK_TPC">{{ s.bnK_TPC }}</div>
                                <div v-else-if="s.amt !== 0">零用現金</div>
                            </td>
                            <td class="right"><Money :v="s.amt" /></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="detail-section">
                <div class="section-title">獎金</div>
                <table cellspacing="0" cellpadding="0" class="accounting-detail-table" style="margin-top: 15px">
                    <thead>
                        <tr>
                            <th>項目</th>
                            <th>付款日期</th>
                            <th>付款帳戶</th>
                            <th class="right">付款金額</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(s, index) in bonusTableData" :key="index">
                            <td>{{ s.name }}</td>
                            <td>{{ s.dat | dateFormater("YYYY-MM-dd") }}</td>
                            <td>
                                <div v-if="s.bnK_TPC">{{ s.bnK_TPC }}</div>
                                <div v-else-if="s.amt !== 0">零用現金</div>
                            </td>
                            <td class="right"><Money :v="s.amt" /></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="detail-section">
                <div class="section-title">人事費用 - 公司負擔</div>
                <table cellspacing="0" cellpadding="0" class="accounting-detail-table" style="margin-top: 15px">
                    <thead>
                        <tr>
                            <th>項目</th>
                            <th>繳款日期</th>
                            <th>付款帳戶</th>
                            <th class="right">公司負擔金額</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(s, index) in staffCostItemsTableData" :key="index">
                            <td>{{ s.name }}</td>
                            <td>{{ s.dat | dateFormater("YYYY-MM-dd") }}</td>
                            <td>
                                <div v-if="s.bnK_TPC">{{ s.bnK_TPC }}</div>
                                <div v-else-if="s.amt !== 0">零用現金</div>
                            </td>
                            <td class="right"><Money :v="s.amt" /></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="detail-section">
                <div class="section-title">人事費用 - 繳款單金額</div>
                <table cellspacing="0" cellpadding="0" class="accounting-detail-table" style="margin-top: 15px">
                    <thead>
                        <tr>
                            <th>項目</th>
                            <th>繳款日期</th>
                            <th class="right">繳款單金額</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(s, index) in staffCostMoneyInfoTableData" :key="index">
                            <td>{{ s.name }}</td>
                            <td>{{ s.dat | dateFormater("YYYY-MM-dd") }}</td>
                            <td class="right"><Money :v="s.amt" /></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import { head } from 'lodash';
import moment from 'moment';

export default {
    props: {
        datas: {
            type: Object,
            default: () => {},
        },
    },
    components: {},
    data() {
        return {};
    },
    computed: {
        documentDetail() {
            const DATA = this.datas?.detail || {
                bonusItems: [],
                fixedSalaryItems: [],
                nonFixedSalaryItems: [],
                staffCostItems: [],
                statisticsInfo: {},
                statisticsItems: [],
            };
            return {
                amount: DATA.amount,
                bonusItems: head(DATA.bonusItems),
                fixedSalaryItems: head(DATA.fixedSalaryItems),
                nonFixedSalaryItems: head(DATA.nonFixedSalaryItems),
                staffCostItems: head(DATA.staffCostItems),
                statisticsInfo: DATA.statisticsInfo,
                statisticsItems: head(DATA.statisticsItems),
            };
        },
        summaryText() {
            const DATA = this.documentDetail.fixedSalaryItems;
            if (!DATA) return '';
            const TIME = moment(`${DATA.year}/${DATA.month}/01`).format('YYYY-MM');
            return `${TIME} 薪資支出`;
        },
        fixedSalaryTableData() {
            const DATA = this.documentDetail.fixedSalaryItems;
            if (!DATA) return [];
            return [
                {
                    name: '代扣稅額',
                    amt: DATA.withholdingTax,
                    dat: DATA.withholdingTaxPaymentDate,
                    bnK_TPC: DATA.withholdingTaxBankName,
                },
                {
                    name: '代扣勞保',
                    amt: DATA.withholdingLabor,
                    dat: DATA.withholdingLaborPaymentDate,
                    bnK_TPC: DATA.withholdingLaborBankName,
                },
                {
                    name: '代扣健保',
                    amt: DATA.withholdingHealth,
                    dat: DATA.withholdingHealthPaymentDate,
                    bnK_TPC: DATA.withholdingHealthBankName,
                },
                {
                    name: '其他代扣',
                    amt: DATA.withholdingOther,
                    dat: DATA.withholdingOtherPaymentDate,
                    bnK_TPC: DATA.withholdingOtherBankName,
                },
                {
                    name: '實付薪資',
                    amt: DATA.amt,
                    dat: DATA.paY_DAT,
                    bnK_TPC: DATA.bnK_TPC,
                },
            ];
        },
        nonFixedSalaryTableData() {
            const DATA = this.documentDetail.nonFixedSalaryItems;
            if (!DATA) return [];
            return [
                {
                    name: '代扣稅額',
                    amt: DATA.withholdingTax,
                    dat: DATA.withholdingTaxPaymentDate,
                    bnK_TPC: DATA.withholdingTaxBankName,
                },
                {
                    name: '代扣勞保',
                    amt: DATA.withholdingLabor,
                    dat: DATA.withholdingLaborPaymentDate,
                    bnK_TPC: DATA.withholdingLaborBankName,
                },
                {
                    name: '代扣健保',
                    amt: DATA.withholdingHealth,
                    dat: DATA.withholdingHealthPaymentDate,
                    bnK_TPC: DATA.withholdingHealthBankName,
                },
                {
                    name: '代扣二代健保',
                    amt: DATA.withholding2ndHealth,
                    dat: DATA.withholding2ndHealthPaymentDate,
                    bnK_TPC: DATA.withholding2ndHealthBankName,
                },
                {
                    name: '其他代扣',
                    amt: DATA.withholdingOther,
                    dat: DATA.withholdingOtherPaymentDate,
                    bnK_TPC: DATA.withholdingOtherBankName,
                },
                {
                    name: '實付薪資',
                    amt: DATA.amt,
                    dat: DATA.paY_DAT,
                    bnK_TPC: DATA.bnK_TPC,
                },
            ];
        },
        bonusTableData() {
            const DATA = this.documentDetail.bonusItems;
            if (!DATA) return [];
            return [
                {
                    name: '獎金',
                    amt: DATA.totaL_AMT,
                    dat: DATA.paY_DAT,
                    bnK_TPC: DATA.bnK_TPC,
                },
                {
                    name: '績效',
                    amt: DATA.totaL_AMT2,
                    dat: DATA.paY_DAT,
                    bnK_TPC: DATA.bnK_TPC,
                },
                {
                    name: '代扣稅款',
                    amt: DATA.withholdingEls,
                    dat: DATA.withholdingElsPaymentDate,
                    bnK_TPC: DATA.withholdingElsBankName,
                },
                {
                    name: '代扣二代健保',
                    amt: DATA.withholding2ndHealth,
                    dat: DATA.withholding2ndHealthPaymentDate,
                    bnK_TPC: DATA.withholding2ndHealthBankName,
                },
                {
                    name: '實付薪資',
                    amt: DATA.amt,
                    dat: DATA.paY_DAT,
                    bnK_TPC: DATA.bnK_TPC,
                },
            ];
        },
        staffCostItemsTableData() {
            const DATA = this.documentDetail.staffCostItems;
            if (!DATA) return [];
            return [
                {
                    name: '退休金',
                    amt: DATA.pension.amt,
                    dat: DATA.pension.paY_DAT,
                    bnK_TPC: DATA.pension.bnK_NAM,
                },
                {
                    name: '勞保費',
                    amt: DATA.labor.amt,
                    dat: DATA.labor.paY_DAT,
                    bnK_TPC: DATA.labor.bnK_NAM,
                },
                {
                    name: '健保費',
                    amt: DATA.health.amt,
                    dat: DATA.health.paY_DAT,
                    bnK_TPC: DATA.health.bnK_NAM,
                },
                {
                    name: '二代健保補充保費',
                    amt: DATA.secondHealth.amt,
                    dat: DATA.secondHealth.paY_DAT,
                    bnK_TPC: DATA.secondHealth.bnK_NAM,
                },
            ];
        },
        staffCostMoneyInfoTableData() {
            const DATA = this.documentDetail.staffCostItems;
            if (!DATA) return [];
            return [
                {
                    name: '退休金',
                    dat: DATA.pension.paY_DAT,
                    amt: DATA.pension.pamt,
                },
                {
                    name: '勞保費',
                    dat: DATA.labor.paY_DAT,
                    amt: DATA.labor.pamt,
                },
                {
                    name: '健保費',
                    dat: DATA.health.paY_DAT,
                    amt: DATA.health.pamt,
                },
                {
                    name: '二代健保補充保費',
                    dat: DATA.secondHealth.paY_DAT,
                    amt: DATA.secondHealth.pamt,
                },
            ];
        },
    },
};
</script>

<style lang="scss"></style>
